// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap___xTLg","actionsCol":"EnrolledClinics_actionsCol__1A4qx"};